module.exports = __webpack_public_path__ + "img/painpoint4.655923a1.png";